module.exports = __webpack_public_path__ + "media/images/icons/faq-19d536181596af8a0e25344faec79e4a.png";